import { Route, Switch } from 'react-router-dom';

import { VisitsSummary } from '../Visits';
import { BusinessSummary } from '../Business';
import { RejectedSummary } from '../Rejected';
import { AgenciesSummary } from '../Agencies';
import { SetupPage } from '../Setup';
import { ProcedurePage } from '../Procedure';
import { ReasonPage } from '../ReasonCode';
import { PayersPage } from '../Payers';
import { ResolutionPage } from '../ResolutionCode';
import { TaskPage } from '../TaskCode';
import { RequiredFieldsPage } from '../RequiredFields';
import { ExceptionPage } from '../ExceptionCodes';

const Routes = () => (
  <Switch>
    <Route path="/evv/agencies" component={AgenciesSummary} />
    <Route path="/evv/business" component={BusinessSummary} />
    <Route path="/evv/procedure" component={ProcedurePage} />
    <Route path="/evv/rejected" component={RejectedSummary} />
    <Route path="/evv/visits" component={VisitsSummary} />
    <Route path="/evv/setup" component={SetupPage} />
    <Route path="/evv/reason" component={ReasonPage} />
    <Route path="/evv/payers" component={PayersPage} />
    <Route path="/evv/resolution" component={ResolutionPage} />
    <Route path="/evv/task" component={TaskPage} />
    <Route path="/evv/required-fields" component={RequiredFieldsPage} />
    <Route path="/evv/exception" component={ExceptionPage} />
  </Switch>
);

export default Routes;
